import AdminHotelSettings from './admin-hotel-settings-component';

const MODULE_NAME = 'app.admin.hotel-view.settings';
const module = angular
    .module(MODULE_NAME, [])
    .directive(AdminHotelSettings.DIRECTIVE_NAME, AdminHotelSettings);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-hotel-view/admin-hotel-settings/admin-hotel-settings-module.js